import { Tooltip } from "react-tippy";
import { useAutomatedChat } from "./useAutomatedChat";
import SwitchButton from "../../components/toggleSwitch/SwitchButton";
import "./automatedChat.scss";

const AUTOMATED_CHAT_TOOLTIP = "When enabled, chats for talent and contact events (like being hired, deployed, or a job going active) are sent automatically under your name to the recipient.";

const AutomatedChatToggle = () => {
    const { enabled, loading, updateEnabled } = useAutomatedChat();

    if (loading || enabled === null) return null;

    return (
        <Tooltip title={AUTOMATED_CHAT_TOOLTIP} position="bottom" arrow={true} theme="light">
            <div className="automatedChatToggle">
                <SwitchButton
                    checked={enabled}
                    onChange={(e) => updateEnabled(e.target.checked)}
                    label="Automated Chat"
                    removeClass
                    containerClass="d-flex align-items-center"
                    labelClass="automatedChatToggle-label"
                />
            </div>
        </Tooltip>
    );
};

export default AutomatedChatToggle;
